export const LOAN_NUMBER = "מספר הלוואה";
export const LOAN_ORIGINAL_AMOUNT = "סכום הלוואה שהועמדה";
export const REMAINING_LOAN_AMOUNT = "יתרת קרן (נומינלית): ";
export const NEXT_PAYMENT = "החזר קרוב";

export const COPIED = "הועתק";
